import { createSlice } from '@reduxjs/toolkit';

interface CostsClaimState {
  myClaims: any[];
  allClaims: any[];
  pendingL1Claims: any[];
  pendingL2Claims: any[];
  pendingPaymentClaims: any[];
  currentClaim: any | null;
  loading: boolean;
  total: number;
  page: number;
  perPage: number;
  expenseTypes: any[];
  paymentMethods: any[];
  banks: any[];
}

const initialState: CostsClaimState = {
  myClaims: [],
  allClaims: [],
  pendingL1Claims: [],
  pendingL2Claims: [],
  pendingPaymentClaims: [],
  currentClaim: null,
  loading: false,
  total: 0,
  page: 1,
  perPage: 20,
  expenseTypes: [],
  paymentMethods: [],
  banks: [],
};

const costsClaimSlice = createSlice({
  name: 'costsClaim',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setMyClaims: (state, action) => {
      state.myClaims = action.payload.data || [];
      state.total = action.payload.meta?.total || 0;
      state.page = action.payload.meta?.page || 1;
    },
    setAllClaims: (state, action) => {
      state.allClaims = action.payload.data || [];
      state.total = action.payload.meta?.total || 0;
    },
    setCurrentClaim: (state, action) => {
      state.currentClaim = action.payload;
    },
    setExpenseTypes: (state, action) => {
      state.expenseTypes = action.payload || [];
    },
    setPaymentMethods: (state, action) => {
      state.paymentMethods = action.payload || [];
    },
    setBanks: (state, action) => {
      state.banks = action.payload || [];
    },
  },
});

export const { actions, reducer: costsClaimReducer } = costsClaimSlice;
export default costsClaimSlice.reducer;
